export const CartEndpoint = (makeRequest) => {
    return {
        // Returns the patient's active cart or nil if it doesn't exist.
        fetchActive(params, options) {
            return makeRequest('GET', '/v1/cart/', params, options);
        },
        // Adds an item to the patient's active cart. Creates the cart if it doesn't exist.
        addItem(params, options) {
            return makeRequest('POST', '/v1/cart/cart_items', params, options);
        },
        // Removes an item from the patient's cart. Removes the cart if it's the last item.
        removeItem(params, options) {
            const { id, ...query } = params;
            return makeRequest('DELETE', `/v1/cart/cart_items/${id}`, query, options);
        },
        // Updates an item in patient cart. If updates essentials quantity - also updates a prescription.
        updateItem(params, options) {
            const { id, ...query } = params;
            return makeRequest('PUT', `/v1/cart/cart_items/${id}`, query, options);
        },
    };
};
//# sourceMappingURL=cart_endpoint.js.map